import React, { Component } from 'react';
//import { HashRouter, Route, Switch } from 'react-router-dom';
// import { renderRoutes } from 'react-router-config';
import './App.scss';
//import 'antd/dist/antd.css'; 
import 'antd/dist/result.css';

import { connect } from 'react-redux'
import * as actions from './store/actions/auth'
//import { BrowserRouter as Router } from 'react-router-dom'

import LoginLayout from './views/LoginLayout'
// Containers
import * as serverconfig from "./views/serverconn";
import axios from "axios";
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import HomeDashboard from './views/HomeDashboard';
import PackageMovement from './views/PackageMovement';
import { Slider, Statistic, Tabs,Result, Modal,Button,Steps, List, Affix  } from "antd";
import CurrencyFormat from "react-currency-format";
const { Step } = Steps;

class App extends Component {

  state = {
   
  }

  componentDidMount(){
    //this.props.onTryAutoSignup();
  }
   
  render() {
    return (
      <Router>
          <LoginLayout  {...this.props}>
            <Switch>
              <Route 
              exact path='/' 
              component={(props) => {
              return <HomeDashboard {...props}  />;
              }} 
              />
              <Route 
              exact path='/movement/' 
              component={(props) => {
              return <PackageMovement {...props}  />;
              }} 
              />
            </Switch>
          </LoginLayout> 
      </Router>
    );
  }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.token !== null
  }
}

const mapDispatchToProps = dispatch =>{
  return {
    onTryAutoSignup: () => dispatch(actions.authCheckState())
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(App);
